import { CommonModule } from "@angular/common";
import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { CQAccordionComponent } from "~modules/shared/components/cq-accordion/cq-accordion.component";

@Component({
  selector: "cq-dictionary",
  templateUrl: "./cq-dictionary.component.html",
  styleUrls: ["./cq-dictionary.component.scss"],
  standalone: true,
  imports: [CommonModule, CQAccordionComponent, FormsModule],
})
export class CQDictionaryComponent implements OnInit {
  accordionItems = [
    {
      htmlItemHeader: "Conventional",
      htmlItemContent:
        "Conventional foam mainly applied in standard soft foam applications, the density typically ranges from 21 kg/m³ to 55 kg/m³.",
      id: 1,
    },
    {
      htmlItemHeader: "High-Resilience",
      id: 2,
      htmlItemContent:
        "High-resilience foam represents an advancement in polyurethane technology, that makes it a preferred choice for high-quality furniture and bedding products. The density typically ranges from 25 kg/m³ to 60 kg/m³.",
    },
    {
      htmlItemHeader: "% of Height",
      htmlItemContent: "Layer volume as percentage of total mattress height.",
      id: 3,
    },
    {
      htmlItemHeader: "Density",
      id: 4,
      htmlItemContent:
        "Material density is a property in soft foam applications, the density typically ranges from 21 kg/m³ to 60 kg/m³, depending on the specific application and product line.",
    },
    {
      htmlItemHeader: "Layer composition",
      id: 5,
      htmlItemContent: "The mix of Polyol, Isocyanate & Additives in a layer.",
    },
    {
      htmlItemHeader: "PBW",
      id: 6,
      htmlItemContent:
        "Parts By Weight, is a way of expressing the relative weight ratio/proportion of components in a recipe or formula, rather than using volume measurements.",
    },
    {
      htmlItemHeader: "Origin",
      id: 7,
      htmlItemContent: "Where the raw material is derived from.",
    },
    {
      htmlItemHeader: "Bio-Circular",
      id: 8,
      htmlItemContent:
        "Materials derived from waste and residues of ​biological origin (e.g. used cooking oils)​.",
    },
    {
      htmlItemHeader: "Circular",
      id: 9,
      htmlItemContent:
        "Materials derived from waste / processing residues which are not landfilled or burned  (e.g. ELT, general plastic waste).",
    },
    {
      htmlItemHeader: "Bio",
      id: 10,
      htmlItemContent:
        "Materials derived from renewable resources, such as biomass or plant-based raw materials.",
    },

    {
      htmlItemHeader: "Standard",
      id: 11,
      htmlItemContent:
        "Materials derived from traditional petrochemical resources.",
    },

    {
      htmlItemHeader: "Sustainable share",
      id: 12,
      htmlItemContent:
        "The percentage of Covestro CQ materials, as part of total amount material applied, that contribute to a more sustainable future.",
    },
    {
      htmlItemHeader: "PCF",
      id: 13,
      htmlItemContent:
        "Product Carbon Footprint, a key metric uses to measure, track and ultimately reduce the carbon emissions associated with a product. ",
    },
    {
      htmlItemHeader: "PCF reduction",
      id: 14,
      htmlItemContent:
        "The process of lowering various greenhouse gas emissions produced during the lifecycle (cradle-to-Covestro gate), often translated into CO2 equivalent emissions, with the aim to minimize climate impact. ",
    },
    {
      htmlItemHeader: "CO<sub>2</sub>e",
      id: 15,
      htmlItemContent:
        "CO2-equivalent, is a standardized unit used to measure and compare the global warming potential of different greenhouse gases. It expresses the impact of different greenhouse gases in terms of the amount of CO2 that would create the same amount of warming.",
    },
    {
      htmlItemHeader: "Premium",
      id: 16,
      htmlItemContent: "Are the additional cost for a sustainable product.",
    },
    {
      htmlItemHeader: "Abatement cost",
      id: 17,
      htmlItemContent:
        "Expenses incurred to reduce or eliminate pollutants, emissions, or other environmental impacts resulting from its operations.",
    },
  ];

  selectedOption = "Grouped_Area";
  sortedAccordionItems!: any[];

  @Output() closeDictionaryEmitter = new EventEmitter<boolean>();

  ngOnInit(): void {
    this.sortedAccordionItems = this.accordionItems.map((item) => item);
  }

  closeDictionary(): void {
    this.closeDictionaryEmitter.emit(true);
  }

  onOptionChange(): void {
    if (this.selectedOption === "Alphabet") {
      this.sortedAccordionItems = this.sortedAccordionItems.sort((a, b) =>
        a.htmlItemHeader.localeCompare(b.htmlItemHeader),
      );
    } else {
      this.sortedAccordionItems = this.accordionItems.map((item) => item);
    }
  }
}
